import Vue from 'vue'
import App from './App.vue'
import routers from './routers'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import loadingViewerVue from 'loading-view-vue'
Vue.config.productionTip = false
Vue.use(loadingViewerVue)
Vue.use(ElementUI)

Vue.use(VueRouter)
const router = new VueRouter({
  // mode: 'history',
  routes: routers
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
